$(function () {
  var $body = $('body');

  //  Back to top button
  $('body').on('click', '.js-scroll-to-top', function(e) {
    $('html, body').animate({
      scrollTop: $(".pg-page").offset().top
    }, 800);
    e.preventDefault();
  });

  $(window).scroll(function() {
    var s = $(".pg-page");
    var pos = s.position();

    if (s.length) {
      var windowpos = $(window).scrollTop();
      if (windowpos >= pos.top & windowpos <=0) {
        s.removeClass("pg-page--scrolled");
      } else {
        s.addClass("pg-page--scrolled");
      }
    }
  });

  // Initialize slick carousel only if slick is loaded
  if (typeof $.fn.slick !== 'undefined') {
    $('.main-carousel').slick({
      infinite: true,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      draggable: true,
      dots: false,
      autoplay: false,
      adaptiveHeight: false,
      arrows: false,
      touchThreshold: 100,
      useCSS: true,
      useTransform: true,
      asNavFor: '.zoom-carousel',
      accessibility: false,
      focusOnSelect: false
    });

    function initializeSlick() {
      $('.zoom-carousel').slick({
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        draggable: true,
        dots: false,
        autoplay: false,
        adaptiveHeight: true,
        arrows: true,
        prevArrow: $('.prev'),
        nextArrow: $('.next'),
        touchThreshold: 100,
        useCSS: true,
        useTransform: true,
        asNavFor: '.main-carousel',
        accessibility: false,
        focusOnSelect: false
      });
    }

    initializeSlick();

    // Sync active thumbnail with carousel changes
    $('.main-carousel').on('beforeChange', function(event, slick, currentSlide, nextSlide) {
      $('.pg-slider-thumbnail').removeClass('active');
      $('.pg-slider-thumbnail[data-slide-index="' + nextSlide + '"]').addClass('active');
    });
  }

  // Thumbnail click handler to sync with main carousel
  $('body').on('click', '.pg-thumbnail-clickable', function(e) {
    e.preventDefault();
    const slideIndex = $(this).data('slide-index');
    $('.main-carousel').slick('slickGoTo', slideIndex);
    $('.pg-slider-thumbnail').removeClass('active');
    $(this).addClass('active');
  });

  // Desktop zoom toggle
  $('body').on('click', '.pg-open-slider-zoom-desktop', function(e) {
    e.preventDefault();
  
    const index = $(this).data('index') - 1;
    const $zoomContainer = $('.pg-slider-zoom-container');
  
    // Hide from DOM completely (no rendering = no visual transition)
    $zoomContainer.addClass('pg-slider-zoom-container--preload');
  
    // Ensure the correct slide is ready
    $('.zoom-carousel').slick('slickGoTo', index, false);
    $('.zoom-carousel').slick('setPosition');
  
    // Slight delay, then reveal container
    setTimeout(() => {
      $zoomContainer
        .removeClass('pg-slider-zoom-container--preload')
        .addClass('pg-slider-zoom-container--open');
  
      $('.pg-page').addClass('pg-page--zoom');
    }, 20); // Small timeout to allow DOM update
  });

  // Mobile zoom toggle
  $('body').on('click', '.pg-open-slider-zoom-mobile', function(e) {
      e.preventDefault();
      $(".pg-slider-zoom-container").addClass("pg-slider-zoom-container--open");
      $(".pg-page").addClass("pg-page--zoom");

      // Trigger the setPosition method to ensure images are loaded
      $('.zoom-carousel').slick('setPosition');
  });

  // Close zoom container
  $('body').on('click', '.pg-close-zoom', function(e) {
    e.preventDefault();
    $(".pg-zoom-container").removeClass("pg-zoom-container--open");
    $(".pg-slider-zoom-container").removeClass("pg-slider-zoom-container--open");
    $(".pg-page").removeClass("pg-page--zoom");
  });

  //  Collection dropdown toggle
  $('body').on('click', '#pg-shop-nav-toggle', function(e) {
    e.preventDefault();
    $(".pg-shop-nav-mobile-drop-down").toggleClass("pg-shop-nav-mobile-drop-down--open");
  });

  // Search toggle - cache elements and close mobile menu
  var $searchPopup = $(".pg-search-popup");
  var $searchOverlay = $(".pg-search-overlay");
  var $mobileMenuContainer = $(".pg-mobile-menu-container");
  var $searchInput = $(".pg-search-input");
  
  $('body').on('click', '#pg-search-toggle', function(e) {
    e.preventDefault();
    $searchPopup.toggleClass("pg-search-popup--open");
    $searchOverlay.toggleClass("pg-search-overlay--open");
    $(".pg-page").toggleClass("pg-page--search-open").removeClass("pg-page--mobile-menu-open");
    $mobileMenuContainer.removeClass("pg-mobile-menu-container--open");
    $searchInput.val('').focus();
  });

  // Mobile menu toggle - close search if open
  $('body').on('click', '#pg-mobile-menu-toggle', function(e) {
    e.preventDefault();
    $mobileMenuContainer.toggleClass("pg-mobile-menu-container--open");
    $(".pg-page").toggleClass("pg-page--mobile-menu-open").removeClass("pg-page--search-open");
    $searchPopup.removeClass("pg-search-popup--open");
  });

  // Mobile menu sub-toggles - refactored for efficiency
  var menuTypes = ['shop', 'edit', 'collective', 'footer', 'join-us'];
  
  function toggleMobileMenu(activeMenu) {
    menuTypes.forEach(function(menu) {
      var isActive = menu === activeMenu;
      $(".pg-mobile-menu-nav--" + menu).toggleClass("pg-mobile-menu-nav--open", isActive);
      $(".pg-mobile-menu-title--" + menu).toggleClass("pg-mobile-menu-title--open", isActive);
    });
  }

  $('body').on('click', '#js-shop-menu-toggle', function(e) {
    e.preventDefault();
    toggleMobileMenu('shop');
  });

  $('body').on('click', '#js-edit-menu-toggle', function(e) {
    e.preventDefault();
    toggleMobileMenu('edit');
  });

  $('body').on('click', '#js-collective-menu-toggle', function(e) {
    e.preventDefault();
    toggleMobileMenu('collective');
  });

  $('body').on('click', '#js-footer-menu-toggle', function(e) {
    e.preventDefault();
    toggleMobileMenu('footer');
  });

  $('body').on('click', '#js-join-us-menu-toggle', function(e) {
    e.preventDefault();
    toggleMobileMenu('join-us');
  });

  //  Sub menu toggle on mobile
  $('body').on('click', '.js-sizing-chart', function(e) {
    e.preventDefault();
    $(".pg-size-chart-container").toggleClass("pg-size-chart-container--open");
    $(".pg-page").toggleClass("pg-page--size-chart-open");
  });

  // Product info toggles - refactored for efficiency
  var infoTypes = ['returns', 'preorder', 'shipping', 'payment', 'customercare', 'size'];
  
  function toggleProductInfo(activeInfo) {
    var $activeContainer = $(".pg-info-container--" + activeInfo);
    var isCurrentlyOpen = $activeContainer.hasClass("pg-info-container--open");
    
    // Close all
    infoTypes.forEach(function(info) {
      $(".pg-info-container--" + info).removeClass("pg-info-container--open");
    });
    
    // If it wasn't open, open it
    if (!isCurrentlyOpen) {
      $activeContainer.addClass("pg-info-container--open");
    }
  }

  $('body').on('click', '#pg-product-returns-toggle', function(e) {
    e.preventDefault();
    toggleProductInfo('returns');
  });

  $('body').on('click', '#pg-product-preorder-toggle', function(e) {
    e.preventDefault();
    toggleProductInfo('preorder');
  });

  $('body').on('click', '#pg-product-shipping-toggle', function(e) {
    e.preventDefault();
    toggleProductInfo('shipping');
  });

  $('body').on('click', '#pg-product-payment-toggle', function(e) {
    e.preventDefault();
    toggleProductInfo('payment');
  });

  $('body').on('click', '#pg-product-size-toggle', function(e) {
    e.preventDefault();
    toggleProductInfo('size');
  });

  $('body').on('click', '#pg-mainmenu-menu-toggle', function(e) {
    e.preventDefault();
    $(".pg-header-menu-dropdown--shop").toggleClass("pg-header-menu-dropdown--shop-open");
    $(".pg-header").toggleClass("pg-header--shop-open");
  });

  // Fade-in animation for lazy-loaded product images
  $('.product-item__image').each(function() {
    var img = this;
    if (img.complete) {
      $(img).addClass('loaded');
    } else {
      $(img).on('load', function() {
        $(this).addClass('loaded');
      });
    }
  });
});
